// Import custom Flutter SVG icons as React components
import { HomeIcon, ProductIcon, IngredientIcon, SettingsIcon } from '../components/icons'
// Use Heroicons for other icons
import {
  UserGroupIcon,
  TagIcon,
  MapIcon,
  ShieldCheckIcon,
  BuildingStorefrontIcon,
} from '@heroicons/react/24/outline'

export interface NavigationItem {
  id: string
  label: string
  icon: React.ComponentType<any>
  path: string
  isVisible: boolean
}

export interface NavigationConfig {
  mainNavigation: NavigationItem[]
  adminNavigation: NavigationItem[]
}

export const navigationConfig: NavigationConfig = {
  mainNavigation: [
    {
      id: 'home',
      label: 'Accueil',
      icon: HomeIcon,
      path: '/',
      isVisible: true,
    },
    {
      id: 'products',
      label: 'Produits',
      icon: ProductIcon,
      path: '/products',
      isVisible: true,
    },
    {
      id: 'ingredients',
      label: 'Ingrédients',
      icon: IngredientIcon,
      path: '/ingredients',
      isVisible: true,
    },
    {
      id: 'settings',
      label: 'Réglages',
      icon: SettingsIcon,
      path: '/settings',
      isVisible: true,
    },
  ],
  adminNavigation: [
    {
      id: 'admins',
      label: 'Administrateurs',
      icon: UserGroupIcon,
      path: '/admins',
      isVisible: true,
    },
    {
      id: 'categories',
      label: 'Catégories',
      icon: TagIcon,
      path: '/categories',
      isVisible: true,
    },
    {
      id: 'brands',
      label: 'Marques',
      icon: BuildingStorefrontIcon,
      path: '/brands',
      isVisible: true,
    },
    {
      id: 'certifications',
      label: 'Certifications',
      icon: ShieldCheckIcon,
      path: '/certifications',
      isVisible: true,
    },
    {
      id: 'continents',
      label: 'Continents',
      icon: MapIcon,
      path: '/continents',
      isVisible: true,
    },
  ],
}

export const getVisibleNavigation = (isAdmin: boolean = false) => {
  const main = navigationConfig.mainNavigation.filter(item => item.isVisible)
  
  if (isAdmin) {
    return [...main, ...navigationConfig.adminNavigation.filter(item => item.isVisible)]
  }
  
  return main
}